// Function for the Embedded Posts Icon
function EPIcon() {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path d="M14.44,7.69c-0.11-0.06-0.21-0.08-0.32-0.08h-1.27v1.96h1.33c0.1,0,0.2-0.03,0.3-0.09c0.1-0.06,0.18-0.16,0.24-0.31
                    s0.1-0.34,0.1-0.58c0-0.26-0.04-0.46-0.11-0.6C14.64,7.85,14.55,7.75,14.44,7.69z" />

                <path d="M10,0C4.48,0,0,4.48,0,10c0,5.52,4.48,10,10,10s10-4.48,10-10C20,4.48,15.52,0,10,0z M9.16,14.59H2.62V5.41h6.42v2.2h-3.9
                    V8.9h3.34v2.04H5.14v1.45h4.02V14.59z M17,10.13c-0.26,0.48-0.61,0.88-1.06,1.18c-0.45,0.31-0.98,0.46-1.58,0.46h-1.5v2.82h-2.52
                    V5.41h3.96c0.45,0,0.86,0.09,1.24,0.27c0.38,0.18,0.71,0.42,0.98,0.73c0.28,0.31,0.49,0.65,0.64,1.03
                    c0.15,0.38,0.23,0.76,0.23,1.15C17.38,9.13,17.25,9.65,17,10.13z" />
            </g>
        </svg>
    );
}

// Export the Embedded Posts Icon component
export default EPIcon;
